import styled from '@emotion/styled'
import React, { useState } from 'react'
import { __legalDocumentType, __snackBarSeverity, __snackBarText } from '../../constants';
import mainContext from '../../contexts/mainContext';
import { addlegalDocumentController, getPrivacyPolicyController } from '../../Controllers/GeneralSettings';
import TextEditor from '../Common/TextEditor';

const PolicyPage = () => {
    const { setSnackBar, setProfileNavTitle } = React.useContext(mainContext);
    const [data, setData] = useState("");

    const callSnackBar = (msg, type) => {
        setSnackBar({
            status: true,
            text: msg,
            severity: __snackBarSeverity[type]
        });
    }

    const getPolicyPage = async () => {
        const res = await getPrivacyPolicyController();
        if (res && res.status === 500) {
            return callSnackBar(__snackBarText.internalServerError, "error")
        }
        if (res.data.status !== 200) {
            return callSnackBar(res.data.errors[0].message, "error");
        }
        setData(res.data.data?.privacyPolicy?.description);
    }

    const hanldeUpdate = async (newDesc) => {
        const res = await addlegalDocumentController({ type: __legalDocumentType.privacyPolicy, description: newDesc });
        if (res && res.status === 500) {
            return callSnackBar(__snackBarText.internalServerError, "error")
        }
        if (res.data.status !== 200) {
            return callSnackBar(res.data.errors[0].message, "error");
        }
        return callSnackBar("Data updated successfully", "success")
    }
    React.useEffect(() => {
        getPolicyPage();
        setProfileNavTitle("Privacy policy");
        // eslint-disable-next-line
    }, []);
    return (
        <>
            <Container>
                <TextEditor data={data} hanldeUpdate={hanldeUpdate} />
            </Container>
        </>
    )
}

const Container = styled("div")`
    margin-top: 1rem;
    padding-right: 3rem;
`;
export default PolicyPage